class APIS {
	apis() {
		return {
			
			contact: {
				headers: {
					"xt-client-token": null,
				},
				method: "post",
				path: "/send/inquiry",
			},
			sendEmail: {
				headers: {
					"xt-user-token": null,
				},
				method: "post",
				path: "/backend/forgot/password",
			},
			reset: {
				headers: {
					"xt-user-token": null,
				},
				method: "post",
				path: "/backend/reset/password",
			},
		};
	}
}

export default new APIS();
